import { familyMemberService } from "../../services/familyMember.service";
import { familyMemberConstant } from "../constants/familyMember.constants";

export const familyMemberAction = {
    getFamilyMembers,
    getRelationList
};
function getFamilyMembers() {
    return (dispatch) => {
        const promise = new Promise((resolve, reject) => {
            dispatch(request());
            familyMemberService.getFamilyMembers().then((res) => {
                resolve(res);
                dispatch(success(res));
            }).catch(error => {
                reject(error);
                dispatch(failure(error));
            });
        });
        return promise
    };
    function request(res) {
        return { type: familyMemberConstant.FAMILY_MEMBER_LIST_REQUEST, res };
    }
    function success(res) {
        return {
            type: familyMemberConstant.FAMILY_MEMBER_LIST_SUCCESS,
            res,
        };
    }
    function failure(error) {
        return { type: familyMemberConstant.FAMILY_MEMBER_LIST_FAILURE, error };
    }
}

function getRelationList() {
    return (dispatch) => {
        const promise = new Promise((resolve, reject) => {
            dispatch(request());
            familyMemberService.getRelationList().then((res) => {
                resolve(res);
                dispatch(success(res));
            }).catch(error => {
                reject(error);
                dispatch(failure(error));
            });
        });
        return promise;
    };

    function request() {
        return { type: familyMemberConstant.RELATION_LIST_REQUEST };
    }

    function success(res) {
        return {
            type: familyMemberConstant.RELATION_LIST_SUCCESS,
            res,
        };
    }

    function failure(error) {
        return { type: familyMemberConstant.RELATION_LIST_FAILURE, error };
    }
}



// WEBPACK FOOTER //
// ./src/store/actions/familyMember.actions.js